import React, { ReactElement, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Button } from '../molecules';

import { forgotPasswordSubmit } from '../../utils/auth-functions';

import { validateEmail, validatePassword } from '../../utils/validators';

import errorStyling from '../../utils/error-styling';
import openEyes from '../../assets/images/open-eyes.svg';
import closeEyes from '../../assets/images/close-eyes.svg';
export default function ResetPasswordForm(): ReactElement {
  const [emailIsValid, setEmailIsValid] = useState<boolean | undefined>(true);
  const [codeIsValid, setCodeIsValid] = useState<boolean | undefined>(undefined);
  const [passwordIsValid, setPasswordIsValid] = useState<boolean | undefined>(true);
  const [passwordIsMatching, setPasswordIsMatching] = useState<boolean | undefined>(undefined);

  const [email, setEmail] = useState<string | undefined>(undefined);
  const [password, setPassword] = useState<string | undefined>(undefined);
  const [confirmPassword, setConfirmPassword] = useState<string | undefined>(undefined);
  const [confirmPasswordIsValid, setConfirmPasswordIsValid] = useState<boolean | undefined>(true);

  const [code, setCode] = useState<string | undefined>(undefined);

  const [response, setResponse] = useState<void | unknown>();
  const [error, setError] = useState<string | undefined>(undefined);
  const [showPwd, setShowPwd] = useState<boolean>(false);
  const history = useHistory();

  const { search } = useLocation();
  const queryString = new URLSearchParams(search);
  /* const redirectUrl = queryString.get('redirectUrl'); */
  const inApp = queryString.get('inApp');

  const handleSetPassword = () => {
    if (passwordIsValid && emailIsValid && email && code && password && passwordIsMatching)
      forgotPasswordSubmit({ username: email, newPassword: password, code }).then((res) => {
        setResponse(res);
      });
    if (email) {
      if (validateEmail({ email }) === 'valid') setEmailIsValid(true);
      else setEmailIsValid(false);
    }

    if (code) setCodeIsValid(true);
    else setCodeIsValid(false);

    if (password) {
      if (validatePassword({ password }) === 'valid') {
        setPasswordIsValid(true);
      } else {
        setPasswordIsValid(false);
      }
    } else {
      setPasswordIsValid(false);
    }
    if (confirmPassword) {
      if (validatePassword({ password: confirmPassword }) === 'valid') {
        setConfirmPasswordIsValid(true);
        if (confirmPassword !== password) setPasswordIsMatching(false);
        else setPasswordIsMatching(true);
      } else {
        setConfirmPasswordIsValid(false);
      }
    } else setPasswordIsMatching(false);
  };

  const handleResponse = () => {
    if (typeof response === 'object' && response) {
      Object.keys(response).forEach((key) => {
        if (key === 'code') {
          const responseString = JSON.stringify(response);
          if (responseString.match('NotAuthorizedException')) setError('NotAuthorizedConfirm');
          else if (responseString.match('LimitExceededException')) setError('LimitExceededException');
          else if (responseString.match('CodeMismatchException')) setError('CodeMismatchException');
          else if (responseString.match('UserNotFoundException')) setError('UserNotFoundException');
        }
      });
    }
  };

  useEffect(() => {
    if (response === 'SUCCESS' && code) {
      history.replace(inApp === 'true' ? '/?confirmedUser=true&inApp=true' : '/?confirmedUser=true');
    }
    if (response === 'SUCCESS') {
      console.log('success');
    } else handleResponse();
  }, [response]);

  return (
    <form id="verification-form">
      <div className="form-group">
        <div className="input-group">
          <input onChange={(e) => setEmail(e.target.value)} type="email" name="username" className="form-control w-100" placeholder="Email" />
        </div>
      </div>
      {emailIsValid !== undefined && !emailIsValid && <div className="input-not-valid mb-2">Email non valida!</div>}

      <div className="form-group">
        <div className="input-group">
          <input onChange={(e) => setCode(e.target.value)} type="text" name="verification_code" className="form-control" placeholder="Codice di verifica" />
        </div>
      </div>
      {codeIsValid === false && <div className="input-not-valid">Inserire un codice valido!</div>}

      <div className="form-group pwd">
        <img
          onClick={() => {
            setShowPwd(!showPwd);
          }}
          src={showPwd ? closeEyes : openEyes}
          className="eyes"
        />
        <div className="input-group">
          <input onChange={(e) => setPassword(e.target.value)} type={showPwd ? 'text' : 'password'} id="password" name="password" className="form-control" placeholder="Nuova password" />
        </div>
      </div>
      {passwordIsValid === false && (
        <div className="input-not-valid mb-2">
          Password non valida!
          <br /> Assicurati di aver inserito almeno 8 caratteri di cui un carattere speciale, maiuscolo, minuscolo ed un numero.
        </div>
      )}

      <div className="form-group">
        <div className="input-group">
          <input onChange={(e) => setConfirmPassword(e.target.value)} type={showPwd ? 'text' : 'password'} name="password_confirmation" className="form-control" placeholder="Conferma nuova password" />
        </div>
      </div>
      {passwordIsMatching === false && <div className="input-not-valid mb-2">Le password non corrispondono.</div>}
      {confirmPasswordIsValid === false && (
        <div className="input-not-valid mb-2">
          Password non valida!
          <br /> Assicurati di aver inserito almeno 8 caratteri di cui un carattere speciale, maiuscolo, minuscolo ed un numero.
        </div>
      )}

      <div className="d-flex align-items-center flex-column">
        <Button role="button" type={'submit'} action={() => handleSetPassword()} className="btn override btn-primary mt-3 mb-2 text-center">
          Resetta
        </Button>
      </div>
      {error !== undefined && <div className="input-not-valid text-center m-0">{errorStyling(error)}</div>}
    </form>
  );
}
